import { createAsyncThunk } from '@reduxjs/toolkit';
import { _switchUserRole } from '@custom/Utils/constants/apiUrls';

const switchUserRole = createAsyncThunk(
  'switchUserRole',
  async (data: { userId: string; newRole: string; newType: string }, { rejectWithValue }) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    
    if (!token) {
      return rejectWithValue('No authentication token found');
    }

    try {
      const url = _switchUserRole.switchRole;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const error = await response.json();
        return rejectWithValue(error.message || 'Failed to switch user role');
      }

      return await response.json();
    } catch (error: any) {
      return rejectWithValue(error.message || 'An error occurred');
    }
  }
);

export default switchUserRole;